import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import reducers from './reducers';

const store = createStore(
    reducers, //All reducers
    {}, //Estado inicial
    composeWithDevTools(applyMiddleware(reduxThunk))
);

export default store;
